:host {
  display: block;
  height: 100%;

  /*
	##############################################
	offcanvas mods: fixed header + fixed offCanvas
	##############################################
*/

  .search {
    margin-top: 23px;
    padding: 0 6.25%;
  }

  .navigation {
    &.hidden {
      visibility: hidden;
    }
  }

  ul,
  ol {
    margin: 0;
    padding: 0;
    list-style: outside none none;

    @include wrap-words();
  }

  @include breakpoint($desktopMinusOneMaxWidth) {
    .off-left .off-canvas-wrap {
      overflow: hidden;
      touch-action: pan-y;
    }
  }

  .offcanvas-navigation {
    height: 100%;
    width: 100vw;

    @include breakpoint($medium) {
      width: 33vw;
    }

    .inner-offcanvas {
      background-color: var(--skin-color-white, $ui-white);
      min-height: 100%;
      padding-top: 25px;
      padding-bottom: 25px;
    }

    $this: &;

    .off-canvas-nav-wrapper {
      position: relative;
      overflow: hidden;
      margin-top: 10px;

      nav.main {
        ul {
          position: absolute;
          width: 100%;
          margin-left: 0;
          left: 0;
          box-sizing: border-box;

          li {
            display: block;
            font-size: $mainNavigation-font-size;
            border-bottom: 1px solid $ui-grey;
            /* stylelint-disable-next-line function-no-unknown */
            margin: 0 gutter() * 4;

            &.headline {
              border-bottom: none;

              .topic {
                @extend %navigationItem;

                color: var(--skin-color-text, $ui-dark);
                padding: 9px 25px 8px 0;
                font-weight: $font-weight-bold;
              }
            }

            .menu-wrapper .overview-link .menu-item {
              font-size: 20px;

              .menu-item-meta {
                display: none;
              }
            }

            a {
              &:not(.btn) {
                @extend %navigationItem;

                border-color: transparent;
                color: var(--skin-color-text, $ui-dark);
                padding: 12px 25px 12px 0;
                position: relative;
              }

              &.btn {
                margin: 10px 0;
              }
            }

            .topic {
              @extend %navigationItem;

              color: var(--skin-color-text, $ui-dark);
              padding: 9px 25px 8px 0;
              font-weight: $font-weight-bold;
            }

            &.has-children > a::after {
              @include getIcon('\e638');

              position: absolute;
              top: 12px;
              right: -5px;
              font-size: 24px;
              color: var(--skin-color-primary, $ui-blue);
            }

            [role='presentation'] ~ [role='presentation'] {
              a::before {
                content: '';
                position: absolute;
                height: 1px;
                width: 100%;
                margin: 0;
                top: -10px;
                background-color: $ui-grey;
              }
            }

            [role='presentation'] {
              background-color: var(--skin-color-secondary-lighter, $ui-grey-minus-3);
              /* stylelint-disable-next-line function-no-unknown */
              padding: 0 gutter() * 4;
              border-bottom: none;
            }

            &.service-nav,
            &.has-flyout-layer {
              margin: -1px 0 1px;
              /* stylelint-disable-next-line function-no-unknown */
              padding: 0 gutter() * 4;
              background-color: var(--skin-color-secondary-lighter, $ui-grey-minus-3);

              &:last-of-type {
                margin-bottom: 0;
              }

              > a {
                border-color: var(--skin-color-secondary-lighter, $ui-grey-minus-3);

                ui-icon {
                  margin-right: 4px;
                }
              }

              li a {
                font-size: $serviceNavigation-font-size;
                line-height: $body-line-height;
                padding: 11px 25px 11px 0;
              }

              &.hasBreakpoint {
                background-color: var(--skin-color-primary-lighter, $ui-blue-minus-5);

                > a {
                  border-color: var(--skin-color-primary-lighter, $ui-blue-minus-5);
                }

                &::after {
                  content: none;
                }

                @include breakpoint($desktop) {
                  display: none;
                }
              }

              &.hasBreakpoint + li::after {
                content: none;
              }
            }

            &.hub-navigation {
              background-color: var(--skin-color-white, $ui-white);
              padding-top: 20px;
              // margin: -1px 0 0; TODO- to be returned when service navigation is added
              margin: 0;

              > .hub-navigation__headline {
                font-size: $serviceNavigation-font-size;
                line-height: $body-line-height;
                /* stylelint-disable-next-line function-no-unknown */
                padding: 9px gutter() * 4;
                color: var(--skin-color-text, $ui-dark);
              }

              ul {
                display: block;
                position: relative;
                margin-left: 0;

                li {
                  position: relative;
                  padding: 0;

                  &:first-child {
                    .hub-link-wrapper::before {
                      content: none;
                    }
                  }

                  &:last-child {
                    .hub-link-wrapper {
                      a {
                        margin-bottom: 10px;
                      }
                    }
                  }

                  .hub-link-wrapper {
                    position: relative;

                    &::before {
                      display: block;
                      content: '';
                      height: 1px;
                      background-color: var(--skin-color-white, $ui-white);
                      position: absolute;
                      top: -10px;
                      width: 100%;
                    }

                    a {
                      @include clearfix;

                      border-width: 0;
                      color: var(--skin-color-text, $ui-dark);
                      padding: 12px 25px 12px 0;
                      margin: 10px 0;
                      position: relative;

                      h2 {
                        @extend %copy;

                        font-weight: $font-weight-bold;
                        color: var(--skin-color-primary, $ui-blue);
                        margin: 0;
                      }

                      p {
                        @extend %metadata;

                        margin-top: 8px;
                      }
                    }
                  }
                }
              }
            }
          }

          ul {
            display: none;
            // 2nd level
            position: absolute;
            top: 0;
            margin-left: 100%;
          }

          &.show-level {
            display: block;
            transition: all 0.25s ease-out;
          }

          li:last-of-type {
            border-bottom: none;
          }
        }

        li.service-nav {
          border-bottom: none;

          & ~ .service-nav {
            a::before {
              content: '';
              position: absolute;
              height: 1px;
              width: 100%;
              margin: 0;
              top: -10px;
              background-color: $ui-grey;
            }
          }

          a:not(.btn) {
            color: var(--skin-color-primary, $ui-blue);
          }

          .overview-link {
            border-bottom: 1px solid #c3c3c3;
          }

          .service-nav {
            background-color: var(--skin-color-white, $ui-white);

            a {
              border-color: var(--skin-color-white, $ui-white);
              font-weight: 600;
            }
          }

          ui-icon {
            height: 24px;
            width: 24px;
            padding-right: 4px;
            vertical-align: bottom;
            box-sizing: content-box;
          }
        }
      }
    }

    .off-canvas-functions {
      /* stylelint-disable-next-line function-no-unknown */
      padding: 0 gutter() * 4;
      height: 40px;

      a {
        font-size: 0;
        text-decoration: none;

        &::before {
          font-size: $serviceNavigation-font-size;
        }

        .no-touchevents &:hover,
        &:hover::before {
          color: var(--skin-color-primary, $ui-blue);
        }
      }

      .close-offcanvas {
        float: right;
      }

      .level-up,
      .close-offcanvas {
        padding: 0;
        border: 0;
        line-height: 0;
        background-color: transparent;
        cursor: pointer;

        .ui-icon {
          width: 40px;
          height: 40px;
        }
      }
    }

    //search area
    .global-search-wrapper {
      margin: 23px 6.25% 0;
    }
  }

  // active states
  nav.main {
    ul {
      @include reset-ul();

      font-size: 0;
      line-height: 26px;

      li {
        @include reset-li();

        font-size: $serviceNavigation-font-size;

        @include breakpoint($desktop) {
          display: inline-block;
        }

        strong {
          font-weight: $font-weight-bold;
        }

        a:not(.btn) {
          color: var(--skin-color-primary, $ui-blue);
          text-decoration: none;
          cursor: pointer;
        }

        &.active {
          @include breakpoint($desktop) {
            a > strong {
              position: relative;
            }
          }
        }

        @include breakpoint($largeMaxWidth) {
          strong:first-child {
            display: block;
            color: var(--component-navigation-element-color, var(--skin-color-primary, $ui-blue));
          }
        }
      }
    }

    li {
      &.active > a strong,
      &.current > a strong,
      &.isActive {
        color: var(--component-navigation-element-color-active-text, var(--skin-color-accent, $ui-green));
      }
    }
  }

  @include breakpoint($desktopMinusOneMaxWidth) {
    .offcanvas.offcanvas--left {
      height: 100vh;
      padding: 0;
      position: fixed;
      right: -$offcanvas-width;
      top: 0;
      width: 100vw;

      @include breakpoint($small) {
        width: 510px;
      }

      .filter__reset__disabled {
        &.is-disabled {
          border-color: var(--skin-color-primary, $ui-blue);
          color: var(--skin-color-primary, $ui-blue);
          cursor: pointer;

          .no-touchevents &:hover {
            background-color: rgba($ui-blue-minus-1, 0.05);
          }
        }
      }

      .inner-offcanvas {
        background-color: var(--skin-color-white, $ui-white);
        min-height: 100%;
        padding: 16px 0;
      }

      .off-right &,
      .off-left & {
        overflow: auto;
        -webkit-overflow-scrolling: touch;
        overflow-x: hidden;
        touch-action: pan-y;
      }
    }
  }

  @include breakpoint($xsmallMaxWidth) {
    .offcanvas.offcanvas--leftSmall {
      height: 100vh;
      position: fixed;
      right: -$offcanvas-width;
      top: 0;
      width: $offcanvas-width;

      .inner-offcanvas {
        background-color: var(--skin-color-white, $ui-white);
        min-height: 100%;
        padding: 16px 0;
      }

      .off-right &,
      .off-left & {
        overflow: auto;
        -webkit-overflow-scrolling: touch;
        overflow-x: hidden;
        touch-action: pan-y;
      }
    }
  }

  .table--isStickyClone,
  .stickyTypeSwitch {
    backface-visibility: hidden;
    transform: translate3d(0, 0, 0);
    transition: transform 0.4s ease-out;

    .off-right & {
      transform: translate(-270px, 0);
      transform: translate3d(-270px, 0, 0);
    }
  }

  .level-up {
    visibility: hidden;
  }
}
